module.exports = __webpack_public_path__ + "img/pslogo1.f7688e8f.png";